/*
 * Copyright (c) 2021-2024. StockAnywhere CC
 * StockAnywhere - https://www.stockanywhere.io
 * View license agreement and terms of use at https://www.stockanywhere.io/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2024-06-30
 */
import React from "react";
import Logo from "../../../assets/img/logo.png";

export const Error = (props: {error: any}) => {
    return (
        <>
            <div className="container m-5 d-flex justify-content-center" >
                <img src={Logo} className="w-25" />
                
            </div>
            <div className="container m-5 d-flex justify-content-center" >
                <p>{props.error}</p>
            </div>
        </>
    );
}